<template>
  <div class="app-container">
    <el-tabs type="card" tab-position="top" >
        <el-tab-pane label="客户存货销售价">
          <sales></sales>
        </el-tab-pane>
        <el-tab-pane label="客户分类存货销售价">
          <sale-category></sale-category>
        </el-tab-pane>
        <el-tab-pane label="客户存货折扣价">
          <inventory></inventory>
        </el-tab-pane>
        <el-tab-pane label="客户存货分类折扣价">
          <inventory-category></inventory-category>
        </el-tab-pane>
        <el-tab-pane label="客户分类存货折扣价">
          <client-inventory></client-inventory>
        </el-tab-pane>
        <el-tab-pane label="客户分类存货分类折扣价">
          <client-inventory-category></client-inventory-category>
        </el-tab-pane>
        <el-tab-pane label="促销价格">
          <promotion  ></promotion>
        </el-tab-pane>
      </el-tabs>
  </div>
</template>
<script>

import clientInventory from './clientinventory/index'
import clientInventoryCategory from './clientinventorycategory/index'
import inventory from './inventory/index'
import inventoryCategory from './inventorycategory/index'
import promotion from './promotion/index'
import saleCategory from './salecategory/index'
import sales from './sales/index'


export default {
  name: 'salemanage',
  components: {
    clientInventory,
    clientInventoryCategory,
    inventory,
    inventoryCategory,
    promotion,
    saleCategory,
    sales
  }

};
</script>

<style lang="scss" scoped>
 

  // /deep/ .el-tabs--top{
  //   height: 680px !important;
  // }

  // .table_bottom{
  //   margin-bottom: 18px;
  // }
</style>